import * as React from "react"
import { useRef } from "react"
import { IconButtonSeeker } from "ui-seeker/core"

import OutsideAlerter from "app/components/modals/useOutsider"
import { useAppCalendarEventsActions } from "../@hooks";

const RELEVANCE_CONFIG = {
    1: { label: 'Low',    color: '#22c55e' },
    2: { label: 'Medium', color: '#f59e0b' },
    3: { label: 'High',   color: '#ef4444' },
}

export const eventsStatus = (level) => {
    const cfg = RELEVANCE_CONFIG[level] || RELEVANCE_CONFIG[1]
    return `${cfg.label} relevance`
}

export default function AppCalendarEventsAction({ date }) {

    const { dayEvents, isOpen, setIsOpen, deleteEvent } = useAppCalendarEventsActions(date)
    const buttonRef = useRef(null)

    if(dayEvents.length === 0) return null

    return <div style={{ overflow: 'visible', position: 'relative' }} className="calendar-icons">
        <div ref={buttonRef}>
            <IconButtonSeeker className='event-icon' icon="calendar-check" iconType="fontAwesome" onClick={() => setIsOpen(true)} />
        </div>
        {isOpen && buttonRef.current && <div className="events-panel">
            <span className="triangle-arrow" />
            <OutsideAlerter
                open={isOpen}
                setOpen={setIsOpen}
                parentRef={buttonRef}
                modalWidth={300}
                modalHeight={200}
                placement={"bottom"}
                align={"end"}
                offsetTop={-130}
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                    {dayEvents.map((e, i) => {
                        const rel = RELEVANCE_CONFIG[e.level] || RELEVANCE_CONFIG[1]
                        return <div key={i} style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '10px',
                            padding: '9px 10px 9px 14px',
                            borderRadius: '8px',
                            background: '#f8faff',
                            border: '1px solid #eef2fb',
                            position: 'relative',
                            overflow: 'hidden',
                        }}>
                            {/* Accent bar */}
                            <div style={{
                                position: 'absolute',
                                left: 0, top: 0, bottom: 0,
                                width: '4px',
                                backgroundColor: rel.color,
                                borderRadius: '8px 0 0 8px',
                            }} />

                            {/* Info */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ fontSize: '13px', fontWeight: 600, color: '#1f2937', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                    {e.name}
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginTop: '2px' }}>
                                    <span style={{ width: '6px', height: '6px', borderRadius: '50%', backgroundColor: rel.color, flexShrink: 0 }} />
                                    <span style={{ fontSize: '11px', color: '#6b7280', fontWeight: 500 }}>
                                        {rel.label} relevance
                                    </span>
                                </div>
                            </div>

                            {/* Delete */}
                            <IconButtonSeeker
                                style={{ width: '32px', height: '32px', minWidth: '32px', flexShrink: 0 }}
                                icon="trash-alt"
                                iconType="fontAwesome"
                                onClick={() => deleteEvent(e.id_event)}
                            />
                        </div>
                    })}
                </div>
            </OutsideAlerter>
        </div>}
    </div>
}